import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

function Charts() {
  const [dates, setDates] = useState(null);
  const [txs, setTxs] = useState(null);

  useEffect(() => {
    const fetchTxs = async () => {
      const url = "/api/v0.1/transaction/count?type=daily"

      axios.get(url)
      .then(response => {
        const datas = response.data.map(item => {
          return item.count
        })
        const APIDates = response.data.map(item => {
          return item.day
        })

        setTxs(datas)
        setDates(APIDates)
      })
      .catch(err => {
        console.log(err)
      });
    }

    fetchTxs();
  }, []);

    const options = {
      chart: {      
        type: 'area',
        backgroundColor: 'rgba(30,34,38,0.7)', // #1e2226
        margin: [40, 30, 70, 90],
      },
      credits: {
        enabled: false,
      },
        accessibility: {
        description: ''
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: dates,
        labels: {
          style: {
              color: 'white'
          }
      }
      },
      yAxis: {
        title: {
          text: 'Transaction',
          style: {
            color: '#ffffff'
          }
        },
        gridLineWidth: 0,
        labels: {
          formatter: function () {
            return this.value / 1000 + 'k';
          },
          style: {
            color: '#ffffff',
          },
        }
      },
      plotOptions: {
        series: {
          lineColor: '#a1f7ff',
          // type: 'datetime',
          animation: {
            duration: 3500, // drawing duration  // 3500 would be good
          }
      },
      area: {
        ointStart: 2000,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          },
          stops: [
            [0, Highcharts.getOptions().colors[1]],
            [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0.2).get('rgba')]
          ]
        },
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 2,
            states: {
              hover: {
                enabled: true
              }
            }
          }
        },
      },
      exporting: {
        enabled: false, // hide context menu button
      },
      series: [{
        showInLegend: false,
        name: 'dDNA Transaction',
        data: txs
        },]      
      }
  

  return (
    <>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </>
  )
}

export default Charts;